var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"box"},[_c('h1',{staticClass:"page-title error--text"},[_vm._v(" "+_vm._s(_vm.localDocumentTitle)+" ")]),_c('p',[_vm._v(" Вы хотите "),_c('RouterLink',{attrs:{"to":{ name: 'sessions' }}},[_vm._v(" вернуться в СДО ")]),_vm._v("? ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }